module.exports = __webpack_public_path__ + "img/negative-review.7d53ea6e.svg";